"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbeddingModelEnum = void 0;
exports.EmbeddingModelEnum = {
    E5Mistral7BInstruct: "e5_mistral_7b_instruct",
    MultilingualE5LargeInstruct: "multilingual_e5_large_instruct",
};
